import React from 'react'
import PropTypes from 'prop-types'

import { DashboardChartPaper, DonutChart } from 'components'

import theme from 'theme'

const TicketByStatus = ({ ticketStatusCount, id }) => {
  return (
    <DashboardChartPaper
      title="Status das Solicitações"
      subtitle="Pendentes, respondidos, atrasados, cancelados e finalizadas"
      heightContainer="fit-content"
    >
      <DonutChart
        id={id}
        title="Processos"
        legendShow
        showName={false}
        names={[
          'Pendente',
          'Respondido',
          'Atrasado',
          'Cancelado',
          'Finalizado',
        ]}
        values={[
          ticketStatusCount?.pending || 0,
          ticketStatusCount?.replied || 0,
          ticketStatusCount?.overdue || 0,
          ticketStatusCount?.canceled || 0,
          ticketStatusCount?.finalized || 0,
        ]}
        colors={[
          theme.palette.dashboard.chart.ticket.pending,
          theme.palette.dashboard.chart.ticket.replied,
          theme.palette.dashboard.chart.ticket.overdue,
          theme.palette.dashboard.chart.ticket.canceled,
          theme.palette.dashboard.chart.ticket.finalized,
        ]}
      />
    </DashboardChartPaper>
  )
}

TicketByStatus.propTypes = {
  ticketStatusCount: PropTypes.object,
  id: PropTypes.string,
}

export default TicketByStatus
